import { computed, watch } from 'vue';

import { useRoute } from 'vue-router';

import i18n from '@/i18n';

import { useSessionStore } from '@/stores/session';

const t = i18n.global.t;

export const useReactiveTitle = () => {
	const route = useRoute();
	const sessionStore = useSessionStore();
	const title = computed(() => {
		const name = route.name;
		if (name == null) {
			return sessionStore.projectTitle;
		}
		return t('title.' + name) + ' | ' + sessionStore.projectTitle;
	});
	watch(title, value => {
		document.title = value;
	}, { immediate: true });
}
